import { render, staticRenderFns } from "./QED.vue?vue&type=template&id=27e0f8cb&scoped=true"
import script from "./QED.vue?vue&type=script&lang=js"
export * from "./QED.vue?vue&type=script&lang=js"
import style0 from "./QED.vue?vue&type=style&index=0&id=27e0f8cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0f8cb",
  null
  
)

export default component.exports